<template>
    <div class="">
        <form-ajax
            v-bind="getInputProps({

            })"

            ref="formAjax"

            v-on:response="processResponse"
        >
            <template #default="{
                msgError,
                msgSuccess,
                isError,
                isInvalid,
                response,
                msg,
                notReload,
                redirectTo,

                getError
            }">
                <slot
                        :msgError="msgError"
                        :msgSuccess="msgSuccess"

                        :loading="loading"
                        :disableSubmit="disableSubmit"

                        :isError="isError"
                        :isInvalid="isInvalid"

                        :response="response"
                        :msg="msg"

                        :notReload="notReload"
                        :redirectTo="redirectTo"

                        :getError="getError"

                        :submit="onClickSubmit"

                        :summary="summary"

                        :coupon="coupon"
                        :updateCoupon="updateCoupon"

                        :checkCoupon="onClickCheckCoupon"
                        :getCouponError="getCouponError"
                >
                    <form action="#">

                    </form>
                </slot>
            </template>
        </form-ajax>

    </div>
</template>

<script>
    import FormAjax from '../FormAjax';

    import mixinCommon from '../mixinCommon';
    import mixinAjax from '../mixinAjax';

    export default {
        mixins: [ mixinCommon, mixinAjax ],

        components: {
            'form-ajax': FormAjax
        },

        props: {
            ...FormAjax.props,

            plan: {
                type: String,
                default: ''
            },
            urlSummary: {
                type: String,
                default: ''
            },
            methodSummary: {
                type: String,
                default: 'get'
            },
            urlCoupon: {
                type: String,
                default: ''
            },
            methodCoupon: {
                type: String,
                default: 'get'
            },
            msgError: {
                type: String,
                default: ''
            },
            msgErrorSummary: {
                type: String,
                default: ''
            },
            msgErrorCoupon: {
                type: String,
                default: ''
            },

            defaultCoupon: {
                type: String,
                default: ''
            },

        },
        data() {
            return {
                invalidCoupon: false,
                disableCoupon: false,

                couponStatus: null,

                coupon: this.disableCoupon,

                couponError: '',

                summary: {
                    subscription: '',
                    billing: '',
                    coupon: '',
                    start_date: '',
                    currency: '',
                    subtotal: '',
                    tax: '',
                    total: ''
                },

                errors: [],

                _t: null,

                loading: false,
                disableSubmit: false
            };
        },

        async mounted() {
            this.loading = true;
            await this.refreshSummary();
            this.loading = false;
        },
        methods: {
            updateCoupon( coupon ) {
                this.coupon = coupon;
            },

            onClickSubmit( evt ) {
                (async ( formSubmit = () => {} ) => {
                    this.loading = true;
                    this.disableSubmit = true;

                    if( await this.checkIsValid() ) {
                        formSubmit();
                    }
                    else {
                        this.errors = [ this.msgError ];
                    }

                    /*this.loading = false;
                    this.disableSubmit = false;*/
                })(this.$refs.formAjax.submit);
            },

            async checkIsValid() {
                return new Promise(( resolve, reject ) => {
                    let validateCard = (c = () => {}) => c( false );
                    for( let child of this.$refs.formAjax.$children ) {
                        if( typeof child.validateCard === 'function' ) {
                            validateCard = child.validateCard;
                            break;
                        }
                    }
                    validateCard( isValid => resolve( isValid ) );
                });
            },

            getCouponError() {
                return this.couponError || '';
            },

            onClickCheckCoupon( evt ) {
                (async () => {
                    this.loading = true;
                    this.disableSubmit = true;

                    await this.checkCoupon();
                    if( !this.invalidCoupon ) {
                        await this.refreshSummary();
                    }
                })();
            },

            async checkCoupon() {
                const { plan, coupon, urlCoupon, methodCoupon } = this;

                let response = null;
                if( coupon && (typeof coupon !== 'string' || coupon.trim()) ) {
                    response = await this.callAjax({ plan, coupon }, urlCoupon, methodCoupon);
                }

                this.couponError = '';

                if( !response ) {
                    this.errors = [ this.msgErrorCoupon ];

                    this.couponStatus = null;
                    this.invalidCoupon = true;

                    this.couponError = this.msgErrorCoupon;

                    this.loading = false;
                    this.disableSubmit = false;

                    return !this.invalidCoupon;
                }

                if( this.ajaxError ) {
                    const { data: resp } = response;
                    this.errors = resp && resp.message ? {coupon: [ resp.message ] } : {coupon: [ this.msgErrorCoupon ] };

                    this.couponStatus = !!+response.status;
                    this.invalidCoupon = true;

                    try {
                        this.couponError = this.errors['coupon'][0]
                    }
                    catch( e ) {
                        this.couponError = this.msgErrorCoupon;
                    }

                    this.loading = false;
                    this.disableSubmit = false;

                    return this.couponStatus;
                }

                this.couponStatus = !!+response.status;
                this.invalidCoupon = !this.couponStatus;

                this.couponError = this.invalidCoupon ? this.couponError || this.msgErrorCoupon : '';

                this.loading = false;
                this.disableSubmit = false;

                return this.couponStatus;
            },

            async refreshSummary() {
                const { plan, coupon, urlSummary, methodSummary } = this;
                let response = await this.callAjax({ plan, coupon }, urlSummary, methodSummary);

                if( !response ) {
                    this.errors = [ this.msgErrorSummary ];
                    return false;
                }

                if( this.ajaxError ) {
                    this.errors = response && response.errors ? response.errors : [ this.msgErrorSummary ];
                }
                if( response.data && typeof response.data.data === 'object' ) {
                    const { data: summary } = response.data;
                    return this.summary = summary;
                }

                return false;
            },

            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( FormAjax, overrideProps );
            },

            processResponse( resp )
            {
                return new Promise(( resolve, reject ) => {
                    let handleCardPayment = (c = () => {}) => c( false );
                    for( let child of this.$refs.formAjax.$children ) {
                        if( typeof child.handleCardPayment === 'function' ) {
                            handleCardPayment = child.handleCardPayment;
                            break;
                        }
                    }

                    if(resp.data.client_secret) {
                        handleCardPayment(resp.data.client_secret, {}, (response) => {
                            if (response.error) {
                                this.loading = false;
                                this.disableSubmit = false;
                                this.$root.$emit('notify', {
                                    'message': response.error.message,
                                    'type': 'error'
                                });
                            } else {
                                document.location.href = resp.data.route_success;
                            }
                        });
                    }
                    if(resp.redirectTo){
                        document.location.href = resp.redirectTo;
                    }
                });

            }
        }
    }
</script>
